<template>
  <div class="presentation-layer" v-if="layerShown">
    <div v-if="true" class="control-and-editor">
			<EditorContent />
			<!-- <Controls /> -->
		</div>
    <PresentationControls></PresentationControls>
  </div>
</template>

<script>
import {mapGetters} from 'vuex';
import EditorContent from './EditorContent.vue';
import Controls from './Controls.vue';
import PresentationControls from './PresentationControls.vue';
export default {
  components: {
    EditorContent,
    Controls,
    PresentationControls
  },
  data () {
    return {
      ready: false
    }
  },
  computed: {
    ...mapGetters({
      layerShown: 'previewControls/layerShown'
    })
  },
  created () {
    this.$bus.on('updateAllScenes', () => {
      this.ready = true;
    })
  }
}
</script>

<style scoped lang="scss">
.presentation-layer {
  position: absolute;
  z-index: 25;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: #666;
}
.control-and-editor {
	position: relative;
	top: 0;
	left: 0;
	box-shadow: 0px 0px 0px 1px #e6e6e6;
}
</style>



// WEBPACK FOOTER //
// src/components/draftPreview/presentationLayer.vue